const Announcements = {
	
	name: 'Announcements',
	model: {

		idProperty: 'announcements__id',
		displayProperty: 'announcements__title',
		
		properties: [
			{ name: 'announcements__id',	mapping: 'id',	type: 'int', },
			{ name: 'announcements__title',	mapping: 'title', },
			{ name: 'announcements__html',	mapping: 'html', },
			{ name: 'announcements__expires',	mapping: 'expires',	type: 'datetime', },
			{ name: 'announcements__isMobile',	mapping: 'isMobile',	type: 'bool',	defaultValue: true, },
			{ name: 'announcements__isAdmin',	mapping: 'isAdmin',	type: 'bool',	defaultValue: true, },
			{ name: 'announcements__enabled',	mapping: 'enabled',	type: 'bool',	defaultValue: true, },
		],

	},

	repository: {
		type: 'onebuild',
	},

};

export default Announcements;
